/* @flow */

import {
    type Recipient,
} from './types';
import { type Pedido } from '../pedidos/types';

const getRecipientDoPedido = ({ usuario }: Pedido): ?Recipient => {
    if (!usuario) {
        return null;
    }
    const [contato] = usuario.contatos;

    if (!contato) {
        return null;
    }

    return {
        name: usuario.nome,
        phone: `${contato.ddd}${contato.numero}`,
    };
};

export default getRecipientDoPedido;
